// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-slide-blur[data-v-a5d06540]{position:absolute;inset:0;width:100%;height:100%;background:#fff;opacity:.7;border:0;overflow:hidden;z-index:1}.frisbuy-slide-blur html[data-v-a5d06540]{overflow:hidden}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
